import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/login'
	},
	{
		path: '/home',
		name: '系统首页',
		component: () => import('@/views/Home.vue'),
		 meta: { requiresAuth: true, showTabs: true } 
	},
	{
		path: '/pricing',
		name: '价格方案',
		component: () => import('@/views/pricing.vue'),
		meta: { permission: false }
	},
	{
		path: '/manager',
		name: 'ManagerPage',
		component:() => import('@/views/AdminPage.vue'),
		meta: { requiresAuth: true, roles: ['admin'], showTabs: true}
	  },
	{
		path: '/points-quota',
		name: '积分配额',
		component: () => import('@/views/PointsQuota.vue'),
		meta: { requiresAuth: true, showTabs: true }
	},
	{
		path: '/table',
		name: '关键词分析',
		component: () => import('@/views/table.vue'),
		meta:{
			permission:false
		}
	},
	{
		path: '/xhs_table',
		name: '关键词分析',
		component: () => import('@/views/xhs_table.vue'),
		meta:{
			permission:false
		}
	},
	{
		path: '/ks_table',
		name: '关键词分析',
		component: () => import('@/views/ks_table.vue'),
		meta:{
			permission:false
		}
	},
	{
		path: '/bili_table',
		name: '关键词分析',
		component: () => import('@/views/bili_table.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/tab',
		name:'tab选项卡',
		component: () => import('@/views/tab.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/form',
		name:'关键词',
		component: () => import('@/views/form.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/note',
		name:'笔记库',
		component: () => import('@/views/note.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/xhs_note_comments',
		name:'客户库',
		component: () => import('@/views/xhs_note_comments.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/douyin_aweme',
		name:'客户库',
		component: () => import('@/views/douyin_aweme.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/douyin_aweme_comment',
		name:'客户库',
		component: () => import('@/views/douyin_aweme_comment.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/bilibili_video',
		name:'客户库',
		component: () => import('@/views/bilibili_video.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/bilibili_video_comments',
		name:'客户库',
		component: () => import('@/views/bilibili_video_comments.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/xhs_note',
		name:'客户库',
		component: () => import('@/views/xhs_note_comments.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/kuaishou_video',
		name:'视频库',
		component: () => import('@/views/kuaishou_video.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/kuaishou_video_comment',
		name:'客户库',
		component: () => import('@/views/kuaishou_video_comment.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/douyin_count',
		name:'账号配置',
		component: () => import('@/views/douyin_count.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/xhs_count',
		name:'账号配置',
		component: () => import('@/views/xhs_count.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/ks_count',
		name:'账号配置',
		component: () => import('@/views/ks_count.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/bili_count',
		name:'账号配置',
		component: () => import('@/views/bili_count.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/pay',
		name:'充值',
		component: () => import('@/views/pay.vue'),
		meta:{
			permission:false
		}
	},
	
	{
		path:'/payqrode',
		name:'扫码',
		component: () => import('@/views/payqrcode'),
		meta:{
			permission:false
		}
	},
	{
		path:'/upload',
		name:'文件上传',
		component: () => import('@/views/upload.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/echart',
		name:'echart图表',
		component:() => import('@/views/echart.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/draggable',
		name:'拖拽列表',
		component:() => import('@/views/draggable.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/dialogDrag',
		name:'拖拽弹框',
		component:() => import('@/views/dialogDrag.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/editor',
		name:'富文本编辑器',
		component:() => import('@/views/editor.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/markdown',
		name:'markdown编辑器',
		component:() => import('@/views/markdown.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/international',
		name:'国际化功能',
		component:() => import('@/views/international.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/404',
		name:'404',
		component:() => import('@/views/404.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/403',
		name:'权限不足',
		component:() => import('@/views/403.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/login',
		name:'login',
		component:() => import('@/views/login.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/excel',
		name:'excel表',
		component:() => import('@/components/bus.vue'),
		children:[{
			path:'exportExcel',
			name:'导出excel',
			component:() => import('@/views/excel/exportExcel.vue'),
			meta:{
				permission:false
			}
		},{
			path:'selectExcel',
			name:'导出已选择项',
			component:() => import('@/views/excel/selectExcel.vue'),
			meta:{
				permission:false
			}
		},{
			path:'mergerHeader',
			name:'导出多级表头',
			component:() => import('@/views/excel/mergerHeader.vue'),
			meta:{
				permission:false
			}
		},{
			path:'uploadExcel',
			name:'上传excel',
			component:() => import('@/views/excel/uploadExcel.vue'),
			meta:{
				permission:false
			}
		}],
		meta:{
			permission:false
		}
	},
	{
		path:'/permission',
		name:'权限测试',
		component:() => import('@/views/permission.vue'),
		meta:{
			permission:true
		}
	},
	{
		path:'/pdf',
		name:'pdf下载',
		component:() => import('@/views/pdf.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/zip',
		name:'导出zip',
		component:() => import('@/views/exportZip.vue'),
		meta:{
			permission:false
		}
	},
	{
		path:'/donate',
		name:'支持我吧',
		component:() => import('@/views/Donate.vue'),
		meta:{
			permission:false
		}
	}
]

const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	// 从 localStorage 中读取token和用户信息
	const token = localStorage.getItem('access_token')
	const userInfo = localStorage.getItem('userInfo')

	// 如果路由不需要登录，直接放行
	if (!to.meta.requiresAuth) {
		next()
	} else if (!token || !userInfo) {
		// 如果需要登录但没有token或用户信息，跳转到登录页
		next('/login')
	} else {
		try {
			const parsedUser = JSON.parse(userInfo)
			const userRole = localStorage.getItem('userRole') || parsedUser.username || ''
			if (!localStorage.getItem('userRole') && userRole) {
				localStorage.setItem('userRole', userRole)
			}

			if (to.meta.roles && to.meta.roles.length > 0 && !to.meta.roles.includes(userRole)) {
				next('/403')
				return
			}
		} catch (error) {
			localStorage.removeItem('access_token')
			localStorage.removeItem('userInfo')
			localStorage.removeItem('userRole')
			next('/login')
			return
		}

		next()
	}
})

export default router
